import React from 'react';
import styles from './index.module.scss';
import Input from '../../components/Input';
import List from './List';
import { ICONS } from '../../constants/icons';
class SearchPlaces extends React.Component {
    constructor(props) {
        super(props);
        this._handleEnter = () => {
            this.setState({
                isOpen: true
            });
        };
        this._handleOut = () => {
            this.setState({
                isOpen: false,
                isSearchStarted: false
            });
        };
        this._handleChange = (e) => {
            var _a, _b, _c;
            const { onClear, onChange } = this.props;
            const isNoEventData = !e || ((_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length) === 0;
            onChange((_c = e.target) === null || _c === void 0 ? void 0 : _c.value);
            this.setState((prevState) => {
                var _a, _b, _c, _d;
                return ({
                    matchValue: ((_a = e.target) === null || _a === void 0 ? void 0 : _a.value) || '',
                    isSearchStarted: prevState.matchValue.length !== ((_c = (_b = e.target) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.length),
                    selectedItem: !((_d = e.target) === null || _d === void 0 ? void 0 : _d.value) ? '' : prevState.selectedItem
                });
            });
            if (isNoEventData) {
                onClear && onClear();
            }
        };
        this._handleSelect = (e) => {
            const { onElemClick } = this.props;
            const { label } = e.target.dataset;
            this.setState({
                isOpen: false,
                selectedItem: e.target.id,
                matchValue: e.target.dataset.label
            });
            onElemClick({ label, id: e.target.id });
        };
        this._getItemLabel = () => {
            const { selectedItem } = this.state;
            const { list } = this.props;
            if (!list) {
                return null;
            }
            const { label } = list.find((item) => item.id === selectedItem) || {};
            return label;
        };
        this._renderInput = () => {
            const { isOpen, matchValue, isSearchStarted } = this.state;
            const { input, isFullWidth, ID, isDisabled } = this.props;
            return (React.createElement(Input, { isDisabled: isDisabled, name: input.name, id: ID, onFocus: this._handleEnter, onBlur: this._handleOut, onChange: this._handleChange, isControlledMode: true, isFullWidth: isFullWidth, isError: input.isError, description: input.description, value: isSearchStarted ? matchValue : this._getItemLabel() || matchValue, type: 'text', label: input.label, placeholder: input.placeholder, withIcon: false, iconName: isOpen ? ICONS.x24.arrow_up : ICONS.x24.arrow_down, isDarkBcg: input.isDarkBcg }));
        };
        this._renderList = () => {
            const { isOpen, matchValue, selectedItem, isSearchStarted } = this.state;
            const { CTAOption, list, isLoading } = this.props;
            if (!isOpen) {
                return null;
            }
            return (React.createElement(List, { isLoading: isLoading, CTAOption: CTAOption, itemsList: list, isSearchStarted: isSearchStarted, onElemClick: this._handleSelect, matchValue: matchValue, selectedItem: selectedItem }));
        };
        this.state = {
            isOpen: false,
            isSearchStarted: false,
            selectedItem: null,
            matchValue: ''
        };
    }
    render() {
        const { isFullWidth } = this.props;
        return (React.createElement("div", { className: `${styles.dropDownWrap} ${isFullWidth ? styles.fullWidth : ''}` },
            this._renderInput(),
            this._renderList()));
    }
}
export default SearchPlaces;
